type JsonLdProps = {
  /** One schema object, or several to emit in a single graph script. */
  data: object | object[]
}

/**
 * Renders a JSON-LD structured-data block as a <script type="application/ld+json">.
 *
 * Server component: because every route is an async Server Component under
 * `output: 'export'`, the script is baked into the static HTML at build time —
 * exactly what search crawlers and AI fetchers parse.
 */
export default function JsonLd({ data }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      // Escape `<` so a stray `</script>` in CMS-derived content (e.g. FAQ
      // answers) can't terminate the tag early — standard JSON-LD hardening.
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, '\\u003c') }}
    />
  )
}
